export default __webpack_public_path__ + "static/new6-10-bf3a76290050c666395d95f5f1faa3a5.png";